import { catalogId, type P, type R, type E, required, arr, get, s, truthy, call, ref, put, phpCopy, PhpArray, values, withWrites, type PortWithWrites } from './support-b2';
import { array_union } from '../../php-compat';
/** PHP: ft_timed_activity_status_ids (includes/functions/janus/encounter/timed_activity_completion.php:22) */
export function ftTimedActivityStatusIds(env: E): P {
    const key = 'ft_timed_activity_status_ids::$ids';
    if ((env.functionStatics[key] ?? null) === null) {
        const ids = new PhpArray();
        env.functionStatics[key] = ids;
        for(const variableName of ['casting','casting_ritual_spell','gathering','lockpicking','reading','training','donning','doffing','disenchanting']) {
            const id=catalogId(env,'StatusEffect',variableName);if(typeof id==='string' && id!=='') ids.set(variableName,id);
        }
    }
    return values(env.functionStatics[key]);
}
/** PHP: ft_timed_activity_owner_blocked (includes/functions/janus/encounter/timed_activity_completion.php:36) */
export function ftTimedActivityOwnerBlocked(owner: P, status: string, env: E): boolean { return call(env,'creature_item_arr_has_blocking_status_flag',{item_arr:owner,flag_key:'no_actions',ignore_status_id:status}); }
/** PHP: ft_timed_activity_finish_precheck (includes/functions/janus/encounter/timed_activity_completion.php:45) */
function ftTimedActivityFinishPrecheckValue(caster: P, item: string, options: P, env: E): P {
    const ability=ref(call(env,'discern_item_id',{item_id:item}));
    if(!arr(ability.value) || !truthy(ability.value)) return "The activity's source no longer exists.";
    put(ability,['item_id_used',0],item);
    const failure=ref(null),copy=ref(phpCopy(caster));
    const ok=call(env,'janus_internal_dispatch_rules',{caster_arr:copy.value,ability_arr:ability.value,options:array_union(options as never,{silent_pre_failure:true}),out_failure_message:failure});
    return ok ? null : s(failure.value ?? 'The activity cannot complete.');
}
/** PHP: ft_timed_activity_is_due (includes/functions/janus/encounter/timed_activity_completion.php:192) */
export function ftTimedActivityIsDue(row: P, campaign: P, env: E): boolean {
    if(call(env,'is_status_effect_permanent',{status_arr:row}) || call(env,'status_instance_has_campaign_pause',{instance:row})) return false;
    return truthy(call(env,'compare_campaign_times',clockArgs(row,campaign,env)));
}
export function clockArgs(row: P, campaign: P, env: E): any {
    const out:Record<string,P>={};
    for(const u of ['year','month','day','hour','minute','second']) {
        out['current_'+u]=call(env,'campaign_field',{campaign_arr:campaign,key:'campaign_time_'+u});out['target_'+u]=get(row,'status_ends_campaign_'+u) ?? 0;
    }
    return out;
}
/** PHP: ft_timed_activity_expire_row (includes/functions/janus/encounter/timed_activity_completion.php:225) */
function ftTimedActivityExpireRowValue(status: P, caster: P, target: R, affected: R, roll: string, env: E): P {
    call(env,'remove_status_effect_status_id_all_connections_to_target',{target_arr:target,affected_ids:affected,status_id:s(required(env,status,'status_id')),roll_id:roll});
    if(truthy(call(env,'ft_campaign_context',{creature_arr:caster})) && truthy(call(env,'ft_campaign_context',{creature_arr:target.value}))) call(env,'insert_log_message',{roll_id:roll,roll_type_1:'status_effect_expired',roll_item_id:s(required(env,status,'status_item_id')),item_id_used_arr:{item_type:['status_effect'],item_name:[call(env,'item_field',{item_arr:status,key:'item_name'}) ?? '']},roll_by_arr:caster,roll_to_arr:target.value});
    return null;
}

export function ftTimedActivityFinishPrecheck(caster: P, item: string, options: P, env: E): PortWithWrites<P> {
    return withWrites(env, env => ftTimedActivityFinishPrecheckValue(caster, item, options, env));
}
export function ftTimedActivityExpireRow(status: P, caster: P, target: R, affected: R, roll: string, env: E): PortWithWrites<P> {
    return withWrites(env, env => ftTimedActivityExpireRowValue(status, caster, target, affected, roll, env));
}
